export default __webpack_public_path__ + "static/media/timer_mask.6cbaa0f5.svg";